import { render, staticRenderFns } from "./allergens.vue?vue&type=template&id=62db0be2&scoped=true"
import script from "./allergens.vue?vue&type=script&lang=js"
export * from "./allergens.vue?vue&type=script&lang=js"
import style0 from "./allergens.vue?vue&type=style&index=0&id=62db0be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62db0be2",
  null
  
)

export default component.exports